import React, {Component} from 'react';
import Alert from 'react-bootstrap/Alert'
import './alert.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle, faFire, faLightbulb } from '@fortawesome/free-solid-svg-icons';

export default class EZNotify extends Component {
  constructor(props) {
    super(props);

    this.allStyles = ["primary", "warning", "danger"];
    this.ourStyles = ["alert-interior ", "alert-text ", "alert-text "]
    this.state = {
      style: this.allStyles.includes(props.styleName) ? props.styleName : this.allStyles[1],
      animation: "alert-fadein"
    };
    this.message = props.message ? props.message : "";
    this.details = props.details ?? undefined
    this.onClose = this.onClose.bind(this);
    this.updateTime = Date.now();
  }
    
  componentDidUpdate(prevProps) {
    if (prevProps.message !== this.props.message || this.fadedDelay()) {
      this.message = this.props.message ? this.props.message : "";
      this.setState({animation: "alert-fadein"});
    }
  } 
  
  fadedDelay()
  {
    return (this.state.animation.localeCompare("alert-fadeout") === 0 && this.updateTime + 5000 < Date.now());
  }

  onClose () {
    this.setState({animation: "alert-fadeout"});
    this.updateTime = Date.now();
  }
  addDetails() {
    if (this.details) {
      return (<p style={{fontSize: '0.8rem'}}><br/>{this.details}</p>)
    }
    else return null
  }
  toastDismissible(displayText, onClose, styleName) {
    const index = this.allStyles.indexOf(styleName) >= 0 ? this.allStyles.indexOf(styleName) : 1;
    const alertStyle = this.ourStyles[index];
    const allStyling = [{icon:faLightbulb, color:'yellow', text:"The thing is"}, 
                        {icon:faExclamationCircle, color:'yellow', text: "Uh-oh."},
                        {icon: faFire, color:'orange', text: "Oh no!"}];

     return(
      <Alert className={alertStyle+this.state.animation} variant={styleName} onClose={onClose} dismissible >
        <h4 className="alert-heading"><FontAwesomeIcon icon={allStyling[index].icon} color={allStyling[index].color}/>&nbsp;
        {allStyling[index].text}</h4>
        {displayText}
        {this.addDetails()}
      </Alert>
    );
  }

  render() {
    const alertLayout = this.props?.container ?? "alert-enclosure"
    if (this.message.length === 0 && this.state.animation.localeCompare ("alert-fadein") === 0)
      return null;
    return (
      <div className={alertLayout}>
        {this.toastDismissible (this.message, this.onClose, this.state.style)}
      </div>
    );
  }
}
